<template>
  <el-dialog title="选择人员" :visible.sync="visible" width="70%" center :close-on-click-modal="false">
    <div class="select-box">
      <div class="select-box-wrap mb15" v-show="staffType != '2'">
        <span>请先选择企业：</span>
        <el-select v-model="tenantGuid" style="width: 300px" filterable placeholder="请选择" @change="getOrganisation">
          <el-option v-for="item in tenantList" :key="item.guid" :label="item.tenantName" :value="item.guid">
          </el-option>
        </el-select>
      </div>
      <div class="box-left fl">
        <el-input v-model="filterText" class="ipt-sty mt15" placeholder="请输入名称"></el-input>
        <p class="fontC-bbb">组织架构</p>
        <el-tree class="filter-tree" :data="areaData" :props="defaultProps" :show-checkbox="true" :check-strictly="true"
          @check="changePerson" node-key="guid" :filter-node-method="filterNodeDep" ref="treeDep"
          @check-change="handleNodeClickPerson">
          <div class="custom-tree-node" slot-scope="{ node, data }">
            <img v-if="data.nodeType == 1" src="../../assets/images/ico_ora.png" alt="" />
            <img v-else src="../../assets/images/icon_per.png" alt="" />
            <span>{{ data.name }}</span>
          </div>
        </el-tree>
      </div>
      <div class="box-right fr">
        <!-- <p class="fontC-bbb fl">已选{{ departmentList.length }}个成员</p> -->
        <el-button size="mini" type="danger" @click="delDepartment()" class="fr" style="margin: 10px 0">删除
        </el-button>
        <el-table :data="departmentList" border height="280px" style="width: 100%">
          <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
          <el-table-column header-align="center" align="left" show-overflow-tooltip prop="name" label="姓名">
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div slot="footer" class="dialog-footer t-right">
      <el-button plain size="medium" @click="visible = false">取消</el-button>
      <el-button size="medium" type="info" @click="departmentSure()">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      defaultProps: {
        id: 'guid',
        label: 'name',
        children: 'children',
        disabled: this.disabledTreeNode,
      },

      visible: false, //部门人员弹框
      defaultCheckedKeys: [],
      area: [],
      departmentList: [], //选中的部门人员数据
      departmentData: '',
      areaData: [], //人员部门数据
      delList: [],
      personGuidList: [], //选中的人员guid
      filterText: '',
      fullscreenLoading: false,
      tenantList: [],
      tenantGuid: null,
    };
  },
  props: ['staffType'],
  watch: {
    filterText(val) {
      this.$refs.treeDep.filter(val);
    },
    staffType(val) {
      if (val == 1 || val == 2) {
        this.tenantGuid = localStorage.guid;
        this.filterText = '';
        this.getOrganisation();
      }
    },
    departmentList: {
      handler(val) {
        console.log(val);
        if (val.length > 1) {
          this.departmentList = [this.departmentList[1]]
          this.$forceUpdate();
        }
      },
      deep: true
    }
  },
  created() {
    this.tenantGuid = localStorage.guid;
    this.getTenantList();
    this.getOrganisation();
  },
  methods: {
    getTenantList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        enterpriseCates: ['9901'],
      };
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tenantList = res.data.data.records || [];
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    open(personGuidList) {
      this.personGuidList = personGuidList;
      this.visible = true;
      this.$nextTick(() => {
        this.$refs.treeDep.setCheckedKeys(this.personGuidList);
        this.departmentList = this.$refs.treeDep.getCheckedNodes();
      });
    },
    changePerson(data, e, l) {
      this.personGuidList = [];
      this.$refs.treeDep.setCheckedKeys([data.guid]);
    },
    //获取组织
    getOrganisation() {
      let self = this;
      let query = {
        tenantGuid: this.tenantGuid,
        isTask: 'Y',
      };
      if (this.staffType == '1'||this.staffType == '2') {//组内
        query = {
          tenantGuid: this.tenantGuid,
          staffType: '1'
        }
      }
      self.api.postJson(`/${serverConfig.msPersonnelService}/organisation/data/get-tree`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.areaData = res.data.data;
        } else {
          self.$message.error(res.data.msg);
          self.areaData = [];
        }
      });
    },
    //禁用 子级选了父级禁用，父级选了子级禁用
    disabledTreeNode(data, node) {
      let list = this.departmentList;
      if (data.nodeType == '1') {//非人员禁用
        return true;
      } else {
        return false;
      }
    },
    //部门弹框选择
    handleNodeClickPerson(data, checked, node) {
      this.departmentList = this.$refs.treeDep.getCheckedNodes();
    },
    filterNodeDep(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    //确定选择部门
    departmentSure() {
      console.log(this.departmentList);
      let name = this.departmentList.length ? this.departmentList[0].name : '';
      this.personGuidList = (this.departmentList || []).map((k) => k.guid);
      this.departmentData = this.departmentList;
      this.$emit('onSelect', [this.personGuidList, this.departmentData, name]);

      this.visible = false;
    },
    //删除部门
    delDepartment() {
      let self = this;
      if (self.departmentList == null || self.departmentList.length == 0) {
        self.$message.error('未选择人员');
        return;
      }
      self
        .$confirm('删除后不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          this.departmentList = this.$refs.treeDep.getCheckedNodes();
          let newArr = [];
          newArr = this.departmentList.filter((item) => this.departmentList.every((one) => one.guid !== item.guid));
          this.$refs.treeDep.setCheckedNodes(newArr); //设置树组件的选中
        });
    },

    handleSelectionChangeDel(val) {
      let self = this;
      self.delList = val;
      console.log(val);
    },
  },
};
</script>

<style scoped>
/deep/ .el-dialog__body {
  height: 410px;
  padding: 0 20px;
}
/* 选择人员弹框 */
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}

.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}

.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}

.select-department {
  color: green;
  text-decoration: underline;
  cursor: pointer;
  margin-left: 0 !important;
}
</style>
